import { fromPromise } from 'xstate';
import { PropertyRequestMinimumCreationDetails } from '@acp/shared';
import { getProperty } from '../property/service';
import { getAddressById } from '../address/service';
import {
    createPropertyRequest,
    getPreflightWorkflows,
    getPropertyRequestById,
    getPropertyRequestWorkflowById,
} from './service';
import { getActiveIntegrations } from '../integration/service';

export const propertyRequestManagerActors = {
    getPreflightWorkflows: fromPromise(async ({
        input,
    }: {
        input: {
            creationDetails: PropertyRequestMinimumCreationDetails;
        };
    }) => getPreflightWorkflows({
        ...input.creationDetails,
    })),
    getExistingFullAddress: fromPromise(async ({
        input,
    }: {
        input: {
            preselectedAddressId: number | null;
            preselectedPropertyId: number | null;
        };
    }) => {
        if (input.preselectedPropertyId !== null) {
            const property = await getProperty(input.preselectedPropertyId);
            const { address } = property;

            return {
                creationDetails: {
                    type: 'existing-property',
                    compliancePropertyId: input.preselectedPropertyId,
                } as const,
                fullAddress: address,
            };
        }
        if (input.preselectedAddressId !== null) {
            const addressDetails = await getAddressById(input.preselectedAddressId);
            const { fullAddress } = addressDetails;

            return {
                creationDetails: {
                    type: 'existing-address',
                    complianceAddressId: input.preselectedAddressId,
                } as const,
                fullAddress,
            };
        }

        return null;
    }),
    createPropertyRequest: fromPromise(async ({
        input,
    }: {
        input: {
            creationDetails: PropertyRequestMinimumCreationDetails;
            stateWorkflowId: string;
            payloadVersionId: string;
        };
    }) => createPropertyRequest({
        ...input.creationDetails,
        stateWorkflowId: input.stateWorkflowId,
        payloadVersionId: input.payloadVersionId,
    })),
    getPropertyRequest: fromPromise(async ({
        input,
    }: {
        input: {
            propertyRequestId: string;
        };
    }) => getPropertyRequestById(input.propertyRequestId)),
    getPropertyRequestWorkflow: fromPromise(async ({
        input,
    }: {
        input: {
            propertyRequestId: string;
        };
    }) => getPropertyRequestWorkflowById(input.propertyRequestId)),
    getPropertyRequestAndWorkflow: fromPromise(async ({
        input,
    }: {
        input: {
            propertyRequestId: string;
        };
    }) => {
        const propertyRequest = await getPropertyRequestById(input.propertyRequestId);
        const workflow = await getPropertyRequestWorkflowById(input.propertyRequestId);
        const agency = await getActiveIntegrations();
        const isIntegrated = agency.length > 0;

        return {
            propertyRequest,
            workflow,
            isIntegrated,
        };
    }),
};
